<template>
  <section class="developer-agreement">
    <!--头部开始-->
    <v-developer-header></v-developer-header>
    <!--头部结束-->

    <!--协议开始-->
    <div class="apply-content">
      <div class="content">
        <p class="dev-center">鲲计划开发者协议</p>
        <p class="indent-2">重要提示：</p>
        <p class="indent-2">天津五麦科技有限公司依据本协议向开发者提供服务，本协议在开发者和天津五麦科技有限公司间具有合同上的法律效力，对双方具有约束力。</p>
        <p  class="indent-2">天津五麦科技有限公司在此特别提醒开发者认真阅读、充分理解本协议各条款，特别是其中所涉及的免除及限制天津五麦科技有限公司责任的条款、对开发者权利限制条款、争议解决和法律适用条款等。</p>
        <p  class="indent-2">请审慎阅读并选择接受或不接受本协议。除非开发者接受本协议所有条款，否则开发者无权使用天津五麦科技有限公司于本协议项下所提供的服务。</p>
        <p  class="indent-2">开发者一经注册鲲计划平台账号或使用本协议下任何服务即视为对本服务条款的充分理解和完全接受。</p>

        <p class="strengthen paragraph">1.定义</p>
          <p  class="indent-2">如无特别说明，下列术语在本协议中的含义为：</p>
          <p>(1)鲲计划平台，是指由天津五麦科技有限公司（以下简称“五麦公司”）基于其拥有的《创造与魔法》游戏基础技术构架提供的独立开发平台，是旨在为开发者提供技术服务的平台，供开发者在平台上开发相关产品，并可通过 鲲计划平台申请将开发完成的产品上传至《创造与魔法》游戏 创意工坊板块供用户使用。</p>
          <p>(2)开发者，指经有效申请并经过五麦公司同意，可以使用鲲计划平台进行产品开发的个人或企业用户。</p>
          <p>(3)产品，指由开发者开发的可向用户提供各种服务的内容，包括但不限于拥有完整世界观的游戏场景、游戏人物、游戏玩法、美术资源、视频或音乐类服务等内容。</p>
          <p>(4)平台基础工具，是指鲲计划平台提供的基础数据及网站数据，开发者可以基于平台基础工具进行产品开发。平台基础数据归属于五麦公司，属于五麦公司财产。</p>
          <p>(5)平台运营数据，是指开发者通过鲲计划平台使用服务及开发产品后，将产品提交的、平台生成的或开发者应用生成的任何数据或信息，包括但不限于用户注册数据，用户行为数据，用户消费数据，用户智能终端属性等数据。平台运营数据是五麦公司的财产。</p>
          <p>(6)商标，是指开发者使用的或同移动游戏产品或相关的手册、促销或销售小册子或其他材料一起使用商标、商品名、标识或特性或其它相当物（无论是否已经注册）。</p>
          <p>(7)著作权，是指由中国版权保护中心出具的《计算机软件著作权登记证书》《美术作品登记证书》等著作权证书，以证明该软件享有相应知识产权的权利。</p>
          <p>(8)服务器，是指五麦公司在指定地点安装有服务器端软件的计算机，鉴于用户数据安全的需要，合作必须使用五麦公司提供的服务器。</p>
          <p>(9)BUG，是指在软件产品依照正确运行的配置需求和开发者提供给最终用户的文件进行运行时出现的影响用户使用该产品或服务的误差、缺陷、错误。BUG可能因为程序代码或系统设计内的缺陷和误差产生。但此错误并不指也不包括任何由外界因素直接或间接造成的缺陷和BUG，外界因素包括但不限于外挂攻击和其它非上述软件的缺陷和BUG引起的因素。</p>

        <p class="strengthen paragraph">2.接受</p>
          <p>(1)您知晓、认可并同意遵守五麦公司《鲲计划开发者协议》。</p>
          <p>(2)当您注册或使用本协议下任何服务时，您知晓、认可并同意遵守《鲲计划开发者协议》。</p>
          <p>(3)五麦公司有权在必要时更新本协议。本协议的每次更新都会在鲲计划平台网站上发布，并立即生效。如果您拒绝接受新的协议，您必须放弃使用五麦公司提供的服务；若您继续使用鲲计划平台，则表明您知晓、认可并同意遵守新的协议。</p>
          <p>(4)五麦公司有权自行决定调整、增加、停止鲲计划平台上的服务或功能。除非特别声明，新功能、新服务将适用此协议。</p>
          <p>(5)开发者违反本协议或相关条款、协议、规则等时五麦公司有权依照其违反情况随时限制或停止向开发者提供鲲计划平台相关服务，并有权追究开发者的相关责任。</p>

        <p class="strengthen paragraph">3.开发者权利和义务</p>
          <p>(1)账号注册</p>
            <p class="indent-1">1)开发者应当通过英雄互娱的平台账号登录鲲计划平台，进行开发者申请，以成为鲲计划平台的开发者。开发者帐户一经申请成功，相应的注册号码（手机号、邮箱等）不得变更，且该帐户与开发者唯一绑定，不可赠与、不可转让、不可继承。</p>
            <p class="indent-1">2)开发者不得违反本协议约定将开发者的账户用于其他目的。否则，五麦公司有权随时单方限制、中止或终止向开发者提供本服务，且未经五麦公司同意开发者不得再次使用本服务。</p>
            <p class="indent-1">3)开发者的鲲计划平台帐号，是开发者登录及使用本服务的凭证。开发者应当做好号码、密码，以及进入和管理本服务中的各类产品与服务的口令、密码等的保密措施。因开发者保密措施不当或开发者的其他行为，致使上述口令、密码等丢失或泄漏所引起的一切损失和后果，均由开发者自行承担。</p>
            <p class="indent-1">4)开发者保证：开发者注册本服务账户的手机、邮箱均是开发者本人合法拥有的。鲲计划平台账号在本服务中进行的包括但不限于以下事项：提交相应资质材料、确认和同意相关协议和规则、选择具体服务类别、进行产品开发以及费用结算等事项，均是开发者自行或开发者授权他人进行的行为，对开发者均有约束力。同时，开发者负责妥善管理前述账号，对该账号项下所发生的一切行为负责，开发者承担以前述号码为标识进行的全部行为的法律责任。</p>
            <p class="indent-1">5)若开发者发现有他人冒用或盗用开发者的账户及密码、或任何其他未经开发者合法授权的情形时，应立即以有效方式通知五麦公司。五麦公司收到开发者的有效请求并核实身份后，会根据不同情况采取相应措施。若开发者提供的信息不完全，导致五麦公司无法核实开发者的身份或无法判断开发者的需求等，而导致五麦公司无法进行及时处理，给开发者带来的损失，开发者应自行承担。同时，五麦公司对开发者的请求采取措施需要合理期限，对于开发者通知五麦公司以及五麦公司根据开发者的有效通知采取措施之前，由于他人行为给开发者造成的损失，五麦公司不承担任何责任。</p>
          <p>(2)产品开发</p>
            <p>鲲计划平台提供的技术服务包含不限于工具及运营、客服系统、策划指导等帮助。根据鲲计划平台提供的平台工具，开发者应使用LUA语言进行产品开发。</p>

          <p>(3)产品保证</p>
            <p class="indent-1">1)开发者保证，使用鲲计划平台开发的相关产品，内容应与《创造与魔法》游戏整体世界观、基调等相吻合。产品不包含任何与《创造与魔法》游戏相抵触的内容，不存在降低或可能降低《创造与魔法》游戏评价的内容。</p>
            <p class="indent-1">2)开发者保证，开发完成的产品，不存在BUG等影响产品正常运转的瑕疵，开发者会根据产品运营情况定期对产品进行更新及调整，保证提供优质的产品和服务。</p>
            <p class="indent-1">3)开发者保证产品内容不得含有任何违反国家法律、法规和政策的信息，包括但不限于：</p>
              <p class="indent-2">a.违反宪法确定的基本原则的；</p>
              <p class="indent-2">b.危害国家统一、主权和领土完整的；</p>
              <p class="indent-2">c.泄露国家秘密、危害国家安全或者损害国家荣誉和利益的；</p>
              <p class="indent-2">d.煽动民族仇恨、民族歧视，破坏民族团结，或者侵害民族风俗、习惯的；</p>
              <p class="indent-2">e.宣扬邪教、迷信的；</p>
              <p class="indent-2">f.散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
              <p class="indent-2">g.宣扬淫秽、色情、赌博、暴力，或者教唆犯罪的；</p>
              <p class="indent-2">h.侮辱、诽谤他人，侵害他人合法权益的；</p>
              <p class="indent-2">i.违背社会公德的；</p>
              <p class="indent-2">j.有法律、行政法规和国家规定禁止的其他内容的。</p>
            <p>4)如开发者产品存在违法、违规或者侵权信息的，由此产生的一切责任由开发者自行承担。如因此给五麦公司造成损失的，开发者应一并承担五麦公司的损失。</p>

          <p>(4)产品发布</p>
            <p>开发者知悉并同意，基于鲲计划平台开发的全部产品，通过审核后仅能用于上传至《创造与魔法》游戏内，供游戏用户使用，并根据产品的评价及用户使用情况、道具购买情况等综合因素，取得开发收益。产品在《创造与魔法》游戏内发布期间，开发者不得将产品另行以任何形式发布至其他平台。</p>

          <p>(5)客户服务</p>
            <p>开发者应就其开发的产品提供客户服务工作，包含不限于线上QQ、微信解答用户咨询，电话反馈用户问题等，及时、妥善的解决用户提出的问题。如果发生用户投诉，开发者应积极主动解决并承担全部责任。因客户服务处理不当导致用户投诉《创造与魔法》游戏的，开发者承担全部责任。</p>

          <p>(6)服务器</p>
            <p>开发者知悉并同意，基于鲲计划平台开发产生的全部内容，均存储在五麦公司购买或拥有合法权利的服务器之上。开发者应根据其使用服务器的数量向五麦公司支付相关费用，费用的支付形式以届时平台要求为准。</p>

        <p class="strengthen paragraph">4.五麦公司权利及义务</p>
          <p>(1)保护开发者的信息安全是五麦公司的一项基本原则，未经开发者的同意，五麦公司不会向五麦公司及其关联方以外的任何公司、组织和个人披露、提供开发者的信息，但下列情形除外：</p>
            <p class="indent-1">1)据本协议或其他相关协议、规则等规定可以提供的；</p>
            <p class="indent-1">2)依据法律法规的规定可以提供的；</p>
            <p class="indent-1">3)行政、司法等政府部门要求提供的；</p>
            <p class="indent-1">4)开发者同意五麦公司向第三方提供；</p>
            <p class="indent-1">5)为解决举报事件、提起诉讼而需要提供的；</p>
            <p class="indent-1">6)为防止严重违法行为或涉嫌犯罪行为发生而采</p>
          <p>(2)尽管五麦公司会对开发者的信息保护做极大的努力，但是仍然不能保证在现有的安全技术措施下，开发者的信息可能会因为不可抗力或非五麦公司因素造成泄漏、窃取等，由此给开发者造成损失的，开发者同意五麦公司可以免责。</p>
          <p>(3)除了另行有约定外，五麦公司无需为按照本协议享有的权益而向开发者支付任何费用。</p>
          <p>(4)开发者理解并同意：为向更多互联网使用者推广开发者的产品，五麦公司有权采取以下行为，而无须再取得开发者的同意。</p>
            <p class="indent-1">1)在第三方平台、网站等采取各种形式对产品进行宣传、推广；</p>
            <p class="indent-1">2)有权为本协议目的使用开发者移动游戏产品的LOGO、标识、名称、图片等相关素材。</p>

        <p class="strengthen paragraph">5.知识产权归属及许可</p>
          <p>(1)五麦公司因履行本协议而提供的所有内容包含不限于开发平台、账号、平台商标，著作权平台基础数据、平台运营数据等全部具有商业价值的资产之知识产权归属于五麦公司所有，授权开发者使用并不视为转让或者无偿许可等。未经五麦公司书面许可，开发者不得将五麦公司提供的内容用于本协议以外之目的和用途。</p>
          <p>(2)开发者在鲲计划平台开发的所有产品，包含不限于著作权、商标权、专利等所有知识产权归属于开发者。开发者在此不可撤销的授权五麦公司，有权使用开发者在鲲计划平台平台开发的所有产品之著作权财产权，包含不限于对开发产品进行复制、改编、信息网络传播等各种权利，并有权对侵权行为以自己的名义进行维权。</p>

        <p class="strengthen paragraph">6.服务的暂停或终止</p>
          <p>(1)开发者应按照五麦公司的要求提交真实准确的相关资料，如五麦公司发现开发者提交的任何信息不真实或不准确的，五麦公司有权暂停或终止向其提供本协议下服务,由此产生的一切法律责任由开发者自行承担。 </p>
          <p>(2)如开发者书面通知或以实际行动表示不接受五麦公司新的服务条款的，五麦公司有权随时暂停或终止向其提供本协议下服务。</p>
          <p>(3)在开发者违反本协议规定、违反任何法律法规或者侵害第三方权益时，五麦公司有权随时暂停或终止向该开发者提供服务。如该开发者后续再直接或间接或以他人名义注册登录鲲计划平台并申请使用登录服务的，五麦公司有权直接单方面暂停或终止提供本协议下服务。</p>
          <p>(4)如本协议服务终止，五麦公司有权选择是否为开发者保留开发者账号中与登录服务相关的任何信息，也可选择是否将信息转发给开发者，也有权选择是否保存开发者的数据及以前的记录。</p>
          <p>如本协议服务终止的，五麦公司有权删除在服务终止前开发者尚未完成或已经完成的全部信息。</p>

        <p class="strengthen paragraph">7.其他</p>
          <p>(1)开发者一经注册或使用本协议下任何服务，即视为开发者已阅读并同意接受本协议及上述内容的约束。五麦公司有权在必要时单方修改本协议或上述内容，相关内容变更后，如果开发者继续使用本服务，即视为开发者已接受修改后的相关内容。 如果开发者不接受修改后的相关内容，应当停止使用相关服务。</p>
          <p>(2)本协议签订地为中华人民共和国北京市朝阳区。</p>
          <p>(3)本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）</p>
          <p>(4)若开发者和五麦公司就本协议发生任何纠纷或争议，首先应当友好协商解决；协商无法达成一致的，双方均同意将纠纷或争议提交本协议签订地有管辖权的人民法院解决。</p>
      </div>
    </div>
    <!--协议结束-->

    <!--同意协议选项开始-->
    <p class="agreement-confirm" onselectstart="return false">
      <span class="base-checkbox-box agreement-checkbox agreement-content-desc">
        <input id="agree" name="test" class="base-checkbox" type="checkbox" @click="agreeFlag = !agreeFlag" />
        <label class="icon-box" for="agree">
          <i class="icon icon-checkbox-unchecked"></i>
        </label>
      </span>
      <span class="greement-content-desc">我已仔细阅读并同意以上</span>
      <span class="agreement-content-tips">协议内容</span>
    </p>
    <!--同意协议选项结束-->

    <!--操作开始-->
    <div class="handle" @click="nextFn">
      <router-link class="handle-btn" :class="!agreeFlag ? 'no-agreement' : ''" :to="agreeFlag ? '/developerInfo' : ''" >下一步</router-link>
    </div>
    <!--操作结束-->

    <!--遮罩层组件开始-->
    <v-basic-mask ref="basicMask" :show="maskFlag" @closeMaskEv="closeMaskFn">
      <span slot="desc">需要同意开发者协议才能提交申请</span>
    </v-basic-mask>
    <!--遮罩层组件结束-->
  </section>
</template>

<script type="text/ecmascript-6">
  // 引入复选框组件
  import checkboxComponent from 'components/checkboxComponent/checkboxComponent'
  // 头部组件
  import developerHeader from 'components/developerHeader/developerHeader'
  // 遮罩提示层
  import basicMask from 'components/basicMask/basicMask'

  export default {
    // 开发者而申请协议
    name: 'developerAgreement',
    data () {
      return {
        // 是否勾选协议
        agreeFlag: false,
        // 弹出层
        maskFlag: false
      }
    },
    methods: {
      // 同意协议后下一步
      nextFn () {
        // 弹出提示框
        this.maskFlag = !this.maskFlag
      },
      closeMaskFn (val) {
        this.maskFlag = val
      }
    },
    components: {
      'v-checkbox': checkboxComponent,
      'v-developer-header': developerHeader,
      'v-basic-mask': basicMask
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "developerAgreement.styl";
  @import "../../assets/stylus/checkbox.styl";
</style>



// WEBPACK FOOTER //
// src/views/developerAgreement/developerAgreement.vue